module.exports = __webpack_public_path__ + "img/news-image8.048235d1.png";